import script from "./StatoIdrosat.vue?vue&type=script&setup=true&lang=js"
export * from "./StatoIdrosat.vue?vue&type=script&setup=true&lang=js"

import "./StatoIdrosat.vue?vue&type=style&index=0&id=78e828cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e828cf"]])

export default __exports__